/**
 * Parses values from Mantine NumberInput, which may be strings while the user types.
 */
export function parseNumberInputValue(value: string | number | null | undefined): number | null {
    if (value === null || value === undefined || value === '') {
        return null
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null
    }

    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : null
}

/**
 * Like {@link parseNumberInputValue}, but returns a fallback when the input is empty or invalid.
 */
export function parseNumberInputValueOr(
    value: string | number | null | undefined,
    fallback: number,
): number {
    return parseNumberInputValue(value) ?? fallback
}
